// Version configuration - Update this file before each deployment
export const APP_VERSION = {
  version: "1.6.7",
  buildDate: "2026-02-10T08:30:00+01:00", // ISO format with France timezone
  
  // Changelog for this version
  changes: [
    {
      type: "feature",
      description: "🎨 Hub Client refonte design pastel : boutons arrondis colorés, KPIs pastels"
    },
    {
      type: "feature",
      description: "📷 Upload logo client : section dédiée dans modal édition + endpoint DELETE"
    },
    {
      type: "feature",
      description: "🔄 Tracking MAJ : date et auteur des modifications visibles sur fiche client"
    },
    {
      type: "feature",
      description: "🎫 Modal Ticket corrigé : schéma API (subject/message), sélection projet"
    },
    {
      type: "feature",
      description: "📊 Graphique CA recharts : évolution sur 12 mois avec animation"
    },
    {
      type: "fix",
      description: "🔧 15 pages corrigées : migration axios → api pour authentification automatique"
    },
    {
      type: "fix",
      description: "🐛 Routes /api/bugs/* : repositionnées pour éviter conflits 404"
    },
    {
      type: "improvement",
      description: "⏰ Version + date/heure déploiement visible dans la sidebar"
    }
  ]
};

// Backlog - Features planned for future releases
export const BACKLOG = [
  {
    priority: "P0",
    status: "planned",
    title: "Refactoring server.py",
    description: "Découper le fichier server.py (~45K lignes) en routers FastAPI séparés par domaine"
  },
  {
    priority: "P1",
    status: "planned",
    title: "Email auto PDF en pièce jointe",
    description: "Attacher le PDF du reçu directement en pièce jointe de l'email"
  },
  {
    priority: "P1",
    status: "planned",
    title: "Synchronisation Google Calendar",
    description: "Corriger l'erreur redirect_uri_mismatch pour la sync calendrier"
  },
  {
    priority: "P2",
    status: "planned",
    title: "Footer sur toutes les pages",
    description: "Ajouter le footer avec version sur toutes les pages de l'application"
  },
  {
    priority: "P2",
    status: "planned",
    title: "Widgets Dashboard",
    description: "Finaliser MyBugReportsWidget et PaymentAlertsWidget sur le dashboard"
  },
  {
    priority: "P3",
    status: "planned",
    title: "Bug image flash info",
    description: "Corriger l'image cassée dans le bandeau d'annonces flash"
  },
  {
    priority: "P3",
    status: "planned",
    title: "Checklist contrats",
    description: "Rendre la checklist cochable dans la vue détail contrat"
  },
  {
    priority: "P3",
    status: "planned",
    title: "Template signature email",
    description: "Appliquer le nouveau template de signature à tous les emails système"
  }
];

// Full version history
export const VERSION_HISTORY = [
  {
    version: "1.6.7",
    date: "2026-02-10T08:30:00+01:00",
    changes: [
      { type: "feature", description: "🎨 Hub Client refonte design pastel : boutons arrondis colorés, KPIs pastels" },
      { type: "feature", description: "📷 Upload logo client : section dédiée dans modal édition + endpoint DELETE" },
      { type: "feature", description: "🔄 Tracking MAJ : date et auteur des modifications visibles sur fiche client" },
      { type: "feature", description: "🎫 Modal Ticket corrigé : schéma API (subject/message), sélection projet" },
      { type: "feature", description: "📊 Graphique CA recharts : évolution sur 12 mois avec animation" },
      { type: "fix", description: "🔧 15 pages corrigées : migration axios → api pour authentification automatique" },
      { type: "fix", description: "🐛 Routes /api/bugs/* : repositionnées pour éviter conflits 404" },
      { type: "improvement", description: "⏰ Version + date/heure déploiement visible dans la sidebar" }
    ]
  },
  {
    version: "1.6.3",
    date: "2026-02-08T20:30:00+01:00",
    changes: [
      { type: "feature", description: "💳 Crédit manuel wallets : page /clients-wallets pour créditer manuellement" },
      { type: "feature", description: "🔢 Nomenclatures : page /settings/nomenclature pour configurer préfixes" },
      { type: "feature", description: "👥 Cartes apporteurs cliquables : voir les leads convertis" },
      { type: "feature", description: "🔗 Noms cliquables partout : clients, membres, projets redirigent vers leurs fiches" },
      { type: "feature", description: "📋 Colonne Référence dans tableaux projets et tickets" },
      { type: "feature", description: "🚀 Filtre EXPRESS : bouton pour filtrer uniquement les projets EXPRESS" },
      { type: "feature", description: "📧 Envoi auto reçus PDF par email au client après paiement" },
      { type: "feature", description: "📊 Onglet Évaluation membre : données réelles" },
      { type: "feature", description: "🗑️ Bouton 'Repartir de zéro' : purge données en conservant équipe et modèles" },
      { type: "feature", description: "🧪 Boutons connexion démo sur la page login" },
      { type: "improvement", description: "📄 Templates PDF modernisés avec logo et couleurs" },
      { type: "improvement", description: "🧹 Menu Sidebar simplifié et réorganisé" },
      { type: "improvement", description: "📝 Footer avec version visible sur les pages admin" },
      { type: "fix", description: "Correction layout page Gestion Virements" },
      { type: "fix", description: "Formulaires Embed restaurés dans le menu Administration" }
    ]
  },
  {
    version: "1.6.2",
    date: "2026-01-27T11:00:00+01:00",
    changes: [
      { type: "feature", description: "🧾 Reçus automatiques : création auto après paiement wallet + numérotation" },
      { type: "feature", description: "📄 Upload facture PDF : agence peut déposer facture en face du reçu" },
      { type: "feature", description: "💬 Bulle messages non lus dans le header avec clignotement" },
      { type: "feature", description: "🔔 Son de notification quand nouveau message (agence)" },
      { type: "improvement", description: "Notifications enrichies : détails paiement pour l'agence" }
    ]
  },
  {
    version: "1.6.1",
    date: "2026-01-27T09:00:00+01:00",
    changes: [
      { type: "feature", description: "📊 Tarification dynamique par paliers : taux horaire dégressif automatique" },
      { type: "feature", description: "🚀 Express : choix entre forfait fixe ou tarification à l'heure" },
      { type: "feature", description: "🏦 Section coordonnées bancaires (RIB) dans les paramètres agence" },
      { type: "fix", description: "Correction bug champs numériques qui préfixaient un '0'" },
      { type: "improvement", description: "Message d'erreur quand les coordonnées bancaires ne sont pas configurées" }
    ]
  },
  {
    version: "1.6.0",
    date: "2026-01-26T20:15:00+01:00",
    changes: [
      { type: "feature", description: "🚀 Intervention Express : nouveau type de projet avec brief simplifié" },
      { type: "feature", description: "Gestion des virements bancaires : affichage RIB + validation agence" },
      { type: "improvement", description: "Fusion des 'Demandes' dans 'Nouveau Projet' - flux unifié" },
      { type: "improvement", description: "Notification au client quand l'agence envoie une estimation" },
      { type: "fix", description: "Redirection notification échéancier vers /my-schedules" }
    ]
  },
  {
    version: "1.5.9",
    date: "2026-01-26T15:00:00+01:00",
    changes: [
      { type: "feature", description: "Création automatique des tâches à partir des livrables du brief - lors de la signature par les deux parties (client + agence)" },
      { type: "feature", description: "Nouveaux champs dans les briefs : 'Livrables agence' et 'Éléments clients attendus'" },
      { type: "improvement", description: "Les livrables cochés dans le brief créent automatiquement des tâches pour le projet" }
    ]
  },
  {
    version: "1.5.8",
    date: "2026-01-26T11:00:00+01:00",
    changes: [
      { type: "fix", description: "Correction 'Envoyer au client pour validation' - ajout champs brief_audio_url/transcript au modèle ProjectCreate" },
      { type: "fix", description: "Correction redirection notifications - route /receipts → /receipts/pending" },
      { type: "fix", description: "Correction calcul crédit wallet utilise available_hours (solde - réservations)" },
      { type: "fix", description: "Protection double-soumission création projet avec useRef" },
      { type: "fix", description: "Ajout id='brief-section' pour scroll 'Lire le brief complet'" },
      { type: "fix", description: "Désactivation des décorations saisonnières par défaut" }
    ]
  },
  {
    version: "1.5.7",
    date: "2026-01-26T09:30:00+01:00",
    changes: [
      { type: "fix", description: "Correction ordre routes /api/receipts/stats et /pending avant /{receipt_id}" },
      { type: "fix", description: "Ajout budget_data, brief_data, inspiration_links, images dans ProjectResponse" }
    ]
  },
  {
    version: "1.5.6",
    date: "2026-01-25T14:45:00+01:00",
    changes: [
      { type: "fix", description: "Correction redirection notifications - navigation avant fermeture dropdown" },
      { type: "fix", description: "Correction fonction 'Mot de passe oublié' - envoi email réparé" }
    ]
  },
  {
    version: "1.5.5",
    date: "2026-01-25T12:00:00+01:00",
    changes: [
      { type: "feature", description: "Lien 'Templates de Brief' ajouté au menu Administration" },
      { type: "feature", description: "Rappels automatiques d'échéances de paiement (job scheduler)" },
      { type: "feature", description: "Bouton 'Envoyer rappel' sur la page des échéanciers" }
    ]
  },
  {
    version: "1.5.4",
    date: "2026-01-24T16:00:00+01:00",
    changes: [
      { type: "feature", description: "Lecteur audio du brief dans la vue projet" },
      { type: "feature", description: "Upload et sauvegarde de l'audio brief lors de la création/édition" }
    ]
  },
  {
    version: "1.5.3",
    date: "2026-01-24T14:00:00+01:00",
    changes: [
      { type: "improvement", description: "Formulaire d'édition brief unifié avec DynamicBriefForm" },
      { type: "fix", description: "Cohérence entre formulaires de création et édition de projet" }
    ]
  },
  {
    version: "1.5.2",
    date: "2026-01-24T11:00:00+01:00",
    changes: [
      { type: "feature", description: "Carte 'Paiement échelonné' sur la page projet avec aperçu des échéances" },
      { type: "feature", description: "Bouton 'Demander paiement' pour envoyer email au client" },
      { type: "improvement", description: "Affichage des montants en HT sur toutes les pages" }
    ]
  },
  {
    version: "1.5.1",
    date: "2026-01-23T15:00:00+01:00",
    changes: [
      { type: "fix", description: "Affichage complet des champs dynamiques du brief dans la vue projet" },
      { type: "feature", description: "Support échéancier jusqu'à 24 mensualités" }
    ]
  },
  {
    version: "1.5.0",
    date: "2026-01-23T10:00:00+01:00",
    changes: [
      { type: "feature", description: "Nouveau flux de création projet avec sélection/création client" },
      { type: "feature", description: "Endpoint POST /users/clients/ pour création client à la volée" },
      { type: "feature", description: "Configuration échéancier de paiement avec acompte personnalisable" }
    ]
  },
  {
    version: "1.4.2",
    date: "2026-01-22T14:00:00+01:00",
    changes: [
      { type: "fix", description: "Correction overflow modal sous-traitant (boutons coupés)" }
    ]
  },
  {
    version: "1.4.1",
    date: "2026-01-22T10:00:00+01:00",
    changes: [
      { type: "feature", description: "Champ 'Estimation Budget' dans les templates de brief (visible agence uniquement)" }
    ]
  },
  {
    version: "1.4.0",
    date: "2026-01-21T15:00:00+01:00",
    changes: [
      { type: "feature", description: "Form Builder - Gestion des templates de brief dynamiques" },
      { type: "feature", description: "13 types de champs disponibles (texte, sélection, couleurs, sitemap, etc.)" },
      { type: "feature", description: "6 templates par défaut par type de projet" },
      { type: "feature", description: "Interface d'administration /agency/brief-templates" }
    ]
  },
  {
    version: "1.2.2",
    date: "2026-01-20T11:45:00+01:00",
    changes: [
      { type: "fix", description: "Correction du montant Stripe: envoi du TTC (HT × 1.20) au lieu du HT" },
      { type: "fix", description: "Correction de l'historique des transactions wallet avec montants HT/TTC" },
      { type: "feature", description: "Affichage du brief complet côté client avec bouton œil et modal détaillé" },
      { type: "improvement", description: "Modal de détails affiche: type de projet, description, liens d'inspiration, images jointes" }
    ]
  },
  {
    version: "1.2.1",
    date: "2026-01-20T11:30:00+01:00",
    changes: [
      { type: "feature", description: "Affichage des coordonnées bancaires (RIB) lors du paiement par virement" },
      { type: "feature", description: "Boutons 'Copier' pour IBAN, BIC et référence de virement" },
      { type: "fix", description: "Correction de la sauvegarde des coordonnées bancaires dans les paramètres" },
      { type: "improvement", description: "Interface améliorée pour les détails bancaires avec icônes et feedback visuel" }
    ]
  },
  {
    version: "1.2.0",
    date: "2026-01-19T19:45:00+01:00",
    changes: [
      { type: "security", description: "Correction du filtrage des données par rôle (projets, tâches, tickets, factures)" },
      { type: "security", description: "Isolation des données entre clients corrigée" },
      { type: "fix", description: "Correction de l'affichage du bouton 'Nouveau domaine' sur la page Domaines" },
      { type: "feature", description: "Ajout des colonnes 'Dernière livraison' et 'Responsable' dans le tableau clients" },
      { type: "feature", description: "Ajout de filtres avancés sur la page clients" },
      { type: "feature", description: "Export CSV des clients pour campagnes marketing" },
      { type: "feature", description: "Système de versioning et manifeste des changements" }
    ]
  },
  {
    version: "1.1.0",
    date: "2026-01-17T14:30:00+01:00",
    changes: [
      { type: "feature", description: "Page publique de demande de devis (/devis)" },
      { type: "feature", description: "Création automatique de prospect et projet brouillon depuis le formulaire devis" },
      { type: "feature", description: "Refonte du tableau clients avec CA et statistiques" },
      { type: "feature", description: "Upload d'avatar et logo entreprise pour les clients" },
      { type: "feature", description: "Carousel d'annonces avec images/vidéos de fond" },
      { type: "fix", description: "Correction du bug pwd_context pour reset password admin" },
      { type: "fix", description: "Correction du bug NaN dans le header (timer et gains)" },
      { type: "fix", description: "Correction du bouton 'Mes tâches' pour les chefs de projet" },
      { type: "fix", description: "Correction du bouton 'Renvoyer identifiants' (spinner infini)" },
      { type: "improvement", description: "URLs dynamiques pour déploiement sur domaine personnalisé" }
    ]
  },
  {
    version: "1.0.0",
    date: "2026-01-10T10:00:00+01:00",
    changes: [
      { type: "feature", description: "Version initiale du MSC Manager" },
      { type: "feature", description: "Gestion des clients, projets, tâches" },
      { type: "feature", description: "Système de tickets et support" },
      { type: "feature", description: "Gestion des contrats et forfaits" },
      { type: "feature", description: "Tableau de bord agence" },
      { type: "feature", description: "Système de facturation" },
      { type: "feature", description: "Gestion des domaines" },
      { type: "feature", description: "Chat interne et notifications" }
    ]
  }
];

// Helper function to format date in French timezone
export const formatVersionDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Get change type badge color
export const getChangeTypeColor = (type) => {
  switch (type) {
    case 'feature':
      return 'bg-emerald-100 text-emerald-700';
    case 'fix':
      return 'bg-amber-100 text-amber-700';
    case 'security':
      return 'bg-red-100 text-red-700';
    case 'improvement':
      return 'bg-blue-100 text-blue-700';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};

// Get change type label in French
export const getChangeTypeLabel = (type) => {
  switch (type) {
    case 'feature':
      return 'Nouveauté';
    case 'fix':
      return 'Correction';
    case 'security':
      return 'Sécurité';
    case 'improvement':
      return 'Amélioration';
    default:
      return 'Autre';
  }
};
